module.exports = __webpack_public_path__ + "static/media/fit-prata.f372c673.webp";